<script lang="ts">
  // Kicker, title and lead at the top of every introduction step.
  // `focus` makes the title the focus target when the step opens;
  // `success` shows title and lead as a confirmation (something was created).
  import { CircleCheck } from '@lucide/svelte';
  import { Notice } from '../../ui';

  interface Props {
    kicker: string;
    title: string;
    lead?: string;
    focus?: boolean;
    success?: boolean;
  }
  let { kicker, title, lead, focus = true, success = false }: Props = $props();
</script>

{#snippet heading()}
  <h2 tabindex="-1" class:compact={success} data-step-focus={focus || undefined}>{title}</h2>
  {#if lead}<p class="lead" class:compact={success}>{lead}</p>{/if}
{/snippet}

<p class="eyebrow kicker">{kicker}</p>
{#if success}
  <Notice tone="success" icon={CircleCheck}>{@render heading()}</Notice>
{:else}
  {@render heading()}
{/if}

<style>
  .kicker { margin-top: var(--space-1_5); color: var(--brand); }
  h2 { font-size: var(--text-2xl); outline: none; }
  .lead { max-width: 520px; margin-bottom: var(--space-3); font-size: var(--text-md); line-height: var(--leading-normal); color: var(--text-2); }

  h2.compact { font-size: var(--text-xl); }
  .lead.compact { margin: var(--space-1) 0 0; }

  @media (max-width: 720px) {
    h2 { font-size: var(--text-xl); }
    .lead { font-size: var(--text-base); }
  }
</style>
